// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__3NZde","inputWrap":"styles_inputWrap__1_u42","input":"styles_input__2h4bu"};